import { CreateSoftTags } from '@/features/createTags';

export default function CreateSoftTagsPage() {
  return <CreateSoftTags />;
}
